import EmailFolder from "@mapmycustomers/shared/enum/EmailFolder";

const analyticsNames: Record<EmailFolder, string> = {
  [EmailFolder.INBOX]: "Inbox",
  [EmailFolder.SENT]: "Sent",
};

const getEmailFolderAnalyticsName = (emailFolder: EmailFolder): string => {
  return analyticsNames[emailFolder];
};

export default getEmailFolderAnalyticsName;
